module.exports = __webpack_public_path__ + "static/media/flowers.526ab1d7.png";